const DebugLogger = (source, log) => {
  // eslint-disable-next-line
  if (process.env.NODE_ENV === "development")
    console.log("Source " + source + "Through error:" + log)
}

export default DebugLogger
